import React from 'react';
import {createRoot} from 'react-dom/client';
import styles from './styles.module.css';

type PageContent = {
    name: string;
    pages?: {name: string; link: string; content: string}[];
    link?: string;
}[];

const CategoryTiles = () => {
    const [content, setContent] = React.useState<PageContent>([]);
    const [hash, setHash] = React.useState(window.location.hash);

    React.useEffect(() => {
        void import('../../page-content.json').then(data => {
            const tiles = data.default.filter(o => o.pages);
            setContent(tiles);
        });
    }, []);

    React.useEffect(() => {
        const handleHashChange = () => {
            setHash(window.location.hash);
        };
        window.addEventListener('hashchange', handleHashChange);
        return () => {
            window.removeEventListener('hashchange', handleHashChange);
        };
    }, []);

    const hasHash = hash.length > 1;
    const tilesToRender = hasHash
        ? (content.find(o => encodeURIComponent(o.name) === hash.substring(1))
              ?.pages ?? [])
        : content;

    return (
        <>
            {hasHash && (
                <a className={styles.backButton} type="button" href="#">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className={`bi bi-arrow-right ${styles.leftArrow}`}
                        viewBox="0 0 16 16"
                    >
                        <path
                            fillRule="evenodd"
                            d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                        />
                    </svg>
                    <b>Back</b>
                </a>
            )}
            <div className={styles.inner}>
                {tilesToRender.map(o => (
                    <a key={o.name} href={o.link ?? `#${o.name}`}>
                        {o.name}
                    </a>
                ))}
            </div>
        </>
    );
};

export default () => {
    const domNode = document.getElementById('category-tiles');
    if (domNode) {
        const root = createRoot(domNode);
        root.render(<CategoryTiles />);
    }
};
